import * as constants from './constants'
import * as ReducerHelper from '@eig-builder/core-utils/helpers/reducer-helper'

const initialState = {
  getInvoicesRetrieving: false,
  postDisregardInvoiceRetrieving: false,
  getCreditsRetrieving: false,
  getRefundsRetrieving: false
}

const reducer = (state = initialState, action) => {
  const listenState =
    ReducerHelper.listenToFetchActions(state, action, constants.GET_INVOICES) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_DISREGARD_INVOICE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_CREDITS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_REFUNDS) ||
    state

  switch (action.type) {
    case constants.POST_DISREGARD_INVOICE_FULFILLED:
      return {
        ...state,
        postDisregardInvoiceResponse: true,
        postDisregardInvoiceRetrieving: false
      }
  }

  if (listenState) {
    return listenState
  }
}

export default reducer
